import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [hover, setHover] = useState("");

  const handleNav = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const linkStyle = (name) => ({
    margin: "6px 0",
    cursor: "pointer",
    color: hover === name ? "#2F66B1" : "#bbb",
    transition: "0.3s",
    fontSize: "14px",
  });

  return (
    <footer
      style={{
        backgroundColor: "#111111",
        color: "#fff",
        padding: "50px 60px",
        marginTop: "0px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {/* Company Info */}
        <div style={{ flex: "1", minWidth: "250px" }}>
          <h2 style={{ marginBottom: "15px", color: "#2F66B1" }}>
            NanoPulse
          </h2>
          <p style={{ lineHeight: "1.7", color: "#ccc" }}>
            We provide advanced pathology and diagnostic solutions with high
            accuracy and modern technology, ensuring reliable healthcare services.
          </p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: "1", minWidth: "200px" }}>
          <h4 style={{ marginBottom: "8px", color: "#2F66B1" }}>
            Quick Links
          </h4>

          {/* Yellow Divider */}
          <div style={styles.divider}></div>


          <ul style={styles.list}>
            <li
              style={linkStyle("home")}
              onClick={() => handleNav("/")}
              onMouseEnter={() => setHover("home")}
              onMouseLeave={() => setHover("")}
            >
              Home
            </li>

            <li
              style={linkStyle("about")}
              onClick={() => handleNav("/about")}
              onMouseEnter={() => setHover("about")}
              onMouseLeave={() => setHover("")}
            >
              About Us
            </li>

            <li
              style={linkStyle("contact")}
              onClick={() => handleNav("/contact")}
              onMouseEnter={() => setHover("contact")}
              onMouseLeave={() => setHover("")}
            >
              Contact
            </li>

            <li
              style={linkStyle("partner")}
              onClick={() => handleNav("/partner")}
              onMouseEnter={() => setHover("partner")}
              onMouseLeave={() => setHover("")}
            >
              Partner
            </li>
          </ul>
        </div>

        {/* Services */}
        <div style={{ flex: "1", minWidth: "200px" }}>
          <h4 style={{ marginBottom: "15px", color: "#2F66B1" }}>Our Services</h4>
          <div style={styles.divider}></div>

          <p style={styles.service}>Blood Testing</p>
          <p style={styles.service}>Full Body Checkup</p>
          <p style={styles.service}>Home Collection</p>
          <p style={styles.service}>Diagnostic Reports</p>
        </div>

        {/* Contact Info */}
        <div style={{ flex: "1", minWidth: "250px" }}>
          <h4 style={{ marginBottom: "15px", color: "#2F66B1" }}>Contact Us</h4>
          <div style={styles.divider}></div>

          <p style={styles.contact}>📍 Bhubaneswar, Odisha , India</p>

          <p style={styles.contact}>
            📧{" "}
            <a
              href="mailto:support@nanopulse.in"
              style={{ color: "#bbb", textDecoration: "none" }}
            >
              support@nanopulse.in
            </a>
          </p>

          <p style={styles.contact}>
            📞{" "}
            <a
              href="tel:+919668246683"
              style={{ color: "#bbb", textDecoration: "none" }}
            >
              +91 9668246683
            </a>
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          borderTop: "1px solid #444",
          marginTop: "35px",
          paddingTop: "15px",
          textAlign: "center",
          fontSize: "13px",
          color: "#aaa",
        }}
      >
        © {new Date().getFullYear()} Nano Cloud Technology. All rights reserved.
      </div>
    </footer>
  );
};

const styles = {
  service: {
    margin: "4px 0",
    color: "#bbb",
    fontSize: "14px",
  },
  list: {
    listStyleType: "disc",
    paddingLeft: "20px",
    margin: 0
  },
  divider: {
    width: "80px",
    height: "3px",
    backgroundColor: "#FFD700",
    marginBottom: "15px",
    borderRadius: "2px"
  },
  contact: {
    margin: "8px 0",
    color: "#bbb",
    fontSize: "14px",
  },
};

export default Footer;